import React, { Component } from 'react';
import PropTypes from 'prop-types';

import typeCheck from 'common/util/typeCheck';

import {
  pickMediaForeignFields,
  getMediaForeignId,
  getMediaForeignTable,
} from 'common/mediaHelpers';

import {
  DATA_TABLE_SOURCE_MEDIA,
  DATA_TABLE_VIEW_ID_MEDIA_BY_ID,
  DATA_TABLE_VIEW_ID_MEDIA_BY_FOREIGN_ID,
} from 'common/dataTableConstants';

import {
  dataTable,
  actionDataTableReset,
  actionDataTableLoadNextPage,
  actionDataTableLoadItems,
} from 'client/helpers/dataTables';
import withInfiniteScroll from 'client/helpers/withInfiniteScroll';

function getDataTableSettingsFromProps(props) {
  const foreignId = getMediaForeignId(props);
  const foreignTable = getMediaForeignTable(props);
  typeCheck('foreignId::PositiveNumber', foreignId);
  typeCheck('foreignTable::NonEmptyString', foreignTable);

  const dataTableSettings = {
    itemsPropName: 'mediaList',
    dataSource: DATA_TABLE_SOURCE_MEDIA,
    viewId: `${DATA_TABLE_VIEW_ID_MEDIA_BY_FOREIGN_ID}_${foreignTable}_${foreignId}`,
    filter: pickMediaForeignFields(props),
    sort: {
      'media.createdDate': 'desc',
    },
    count: 100,
  };
  return dataTableSettings;
}

@dataTable(getDataTableSettingsFromProps)
@withInfiniteScroll({
  offset: 420,
})
class SrDataTableMedia extends Component {
  static propTypes = {
    mediaList: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    const { onInfiniteScrollCallbackReady } = props;
    onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
  }

  componentDidUpdateReceiveProps(prevProps) {
    if (
      getDataTableSettingsFromProps(prevProps).viewId
      !== getDataTableSettingsFromProps(this.props).viewId
    ) {
      this._reloadMediaList();
    }
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, getDataTableSettingsFromProps(this.props));
    }
  }

  _reloadMediaList = () => {
    const { dispatch } = this.props;
    dispatch(actionDataTableReset, { dataSource: DATA_TABLE_SOURCE_MEDIA });
  }

  _reloadMediaById = (mediaId) => {
    const { dispatch } = this.props;
    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_MEDIA,
      viewId: `${DATA_TABLE_VIEW_ID_MEDIA_BY_ID}-${mediaId}`,
      filter: {
        'media.id': mediaId,
      },
      count: 1,
    });
  }

  render() {
    const {
      mediaList,
      children,
      dataTableApiState,
      onInfiniteScrollWrapperRef,
    } = this.props;

    return (
      <div ref={onInfiniteScrollWrapperRef}>
        {dataTableApiState.error && (
          <span>ERROR: { dataTableApiState.error }</span>
        )}
        {children({
          mediaList: mediaList,
          reloadMediaList: this._reloadMediaList,
          reloadMediaById: this._reloadMediaById,
        })}
        {dataTableApiState.inProgress && (
          <div className='loading-ellipses left' />
        )}
      </div>
    );
  }
}

SrDataTableMedia.displayName = 'SrDataTableMedia';

export default SrDataTableMedia;
